/* eslint-disable prettier/prettier */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getCookie } from 'src/utils/dom-utils';

import './AuthenticationContainer.scss';

import { moduleActions } from '../../redux/modules';
import { AuthServiceProvider, AuthGate } from '@trp-ta-nitro/auth-react';
import AuthenticationSpinner from './AuthenticationSpinner';
import { setApiKey, setSalesForceRepCode } from '../../utils/api';

function inAllowedIFrame() {
  try {
    const isSandbox = window.location.host.includes('localhost');
    const isInternalDomain =
      window.location.host.includes('awstrp') || isSandbox;
    const inIFrame = window.self !== window.top; // && iFrameNameIsValid;
    return inIFrame && isInternalDomain;
  } catch (e) {
    return false;
  }
}

function isRepFromSalesforce() {
  return (
    window.location.pathname.includes('salesforce') &&
    window.location.host.includes('awstrp')
  );
}

class AuthenticationContainer extends Component {
  constructor(props) {
    super(props);
    const {
      actions: { setCustomerWebViewContext },
    } = props;
    const isSandbox = window.location.host.includes('localhost');
    const isInternalDomain =
      window.location.host.includes('awstrp') || isSandbox;
    const isIFrame = inAllowedIFrame();
    const isSalesforceRep = isRepFromSalesforce();
    setCustomerWebViewContext({
      isInternalDomain: isInternalDomain,
      isIFrame: isIFrame,
      isSalesforceRep: isSalesforceRep,
    });
  }

  componentDidMount() {
    const {
      authentication: { isSalesforceRep },
      actions: { setSalesforceDepartmentCode, getAPIKey },
      customerWebViewEnabled,
    } = this.props;
    if (
      document.referrer.indexOf('awstrp.net') > 0 &&
      !window.location.host.includes('awstrp')
    ) {
      const currentHost = window.location.host;
      window.location.host = currentHost.replace(
        'troweprice.com',
        'awstrp.net'
      );
    }
    if (isSalesforceRep) {
      const department = getCookie('salesForceDept');
      setSalesForceRepCode(department);
      setSalesforceDepartmentCode(department);
    }

    getAPIKey();
    if (customerWebViewEnabled) {
      this.disableSubmitButton();
    }
  }

  render() {
    const {
      authentication: { apiKey, isLoaded: configLoaded },
    } = this.props;
    setApiKey(apiKey);
    const authOptions = {
      apiKey,
      types: {
        // enable external and internal both, no extra options are required so none are passed
        external: {},
        internal: {
          customerWebViewEnabled: true,
        },
      },
    };
    return configLoaded && apiKey ? (
      <AuthServiceProvider options={authOptions}>
        <AuthGate
          internalEntitlements={[['su-admins'], ['portal_retaildesktop_base']]}
          unauthenticated={() => <h1>Not Authenticated</h1>}
          unauthorized={() => <h1>Not in entitlements range</h1>}
          loading={() => <AuthenticationSpinner />}
        >
          {this.props.children}
        </AuthGate>
      </AuthServiceProvider>
    ) : (
      <AuthenticationSpinner />
    );
  }
}

const mapStateToProps = ({ authentication, language, routing }) => ({
  authentication,
  language,
  routing,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AuthenticationContainer
);
